import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { getAssistBookingApiV2 } from '../../../api/booking';
import { AssistBookingState, ParamsAssistBooking } from '../../../types/booking';
import { RootState } from '../../store';

export const getAssistBookingV2 = createAsyncThunk(
  'admin/check-booking-v2',
  async (params: ParamsAssistBooking, { dispatch, rejectWithValue }) => {
    try {
      const response = await getAssistBookingApiV2(params);
      const { status } = response;
      if (status) {
        dispatch(setUpdate(response));
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(setUpdateError(response));
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const getAssistBookingSlice = createSlice({
  name: 'get-assist-v2',
  initialState: {
    error: false,
    loading: false,
    success: false,
    status: 0,
    message: '',
    listAssistBooking: [],
    listFreeSeat: [],
    segmentSelected: '',
    segmentId: undefined,
    assistTransshipDepart: [],
    assistTransshipArrive: [],
    errorDetail: null,
  } as AssistBookingState,
  reducers: {
    setUpdate: (state: AssistBookingState, { payload }) => {
      state.listAssistBooking = payload?.data?.data;
      state.status = payload?.status;
    },
    setUpdateError: (state: AssistBookingState, { payload }) => {
      const { errors } = payload.data;
      state.status = payload?.status;
      state.errorDetail = errors;
    },
    setListFreeSeat: (state: AssistBookingState, { payload }) => {
      state.listFreeSeat = payload?.free_seats;
      state.segmentSelected = payload?.segment_name;
      state.segmentId = payload?.segment_id;
      state.assistTransshipDepart = payload?.transship_depart
      state.assistTransshipArrive = payload?.transship_arrive
    },
    resetListFreeSeat: (state: AssistBookingState) => {
      state.listFreeSeat = [];
    },
    resetAssistBooking: (state: AssistBookingState) => {
      state.success = false;
      state.message = '';
      state.errorDetail = null;
      state.status = 0;
      state.listAssistBooking = [];
      state.listFreeSeat = [];
      state.segmentSelected = '';
      state.segmentId = undefined;
      state.assistTransshipDepart = [];
      state.assistTransshipArrive = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAssistBookingV2.pending, (state: AssistBookingState) => {
      state.loading = true;
      state.success = false;
    });
    builder.addCase(getAssistBookingV2.fulfilled, (state: AssistBookingState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getAssistBookingV2.rejected, (state: AssistBookingState, { payload }) => {
      state.loading = false;
      state.success = false;
      state.error = true;
      state.message = payload;
    });
  },
});

export const getAssistBookingSelector = (state: RootState) => state.assistBooking;
export const { setUpdateError, setUpdate, resetAssistBooking, setListFreeSeat, resetListFreeSeat } =
  getAssistBookingSlice.actions;
